import type { AddressRange, IpCountMode } from '../../apps/cidr-planner/types';
import type { DisplayLang } from '../../../shared/utils/pageDisplay';
import { CidrSheet } from './CidrSheet';
import { NSplitFields } from './NSplitFields';

type SplitDialogProps = {
  gap: AddressRange;
  ipCountMode: IpCountMode;
  lang: DisplayLang;
  onClose: () => void;
  onConfirm: (payloads: Array<{ cidr: string; name: string }>) => void;
};

const TEXT = {
  ja: {
    title: '空き領域を分割',
    cancel: 'キャンセル',
    close: '閉じる',
  },
  en: {
    title: 'Split free space',
    cancel: 'Cancel',
    close: 'Close',
  },
} as const;

export function SplitDialog({
  gap,
  ipCountMode,
  lang,
  onClose,
  onConfirm,
}: SplitDialogProps) {
  const t = TEXT[lang];

  return (
    <CidrSheet title={t.title} closeLabel={t.close} onClose={onClose}>
      <NSplitFields
        range={gap}
        ipCountMode={ipCountMode}
        lang={lang}
        onSplit={onConfirm}
      />
      <div className="cidr-sheet__actions">
        <button type="button" className="cidr-sheet__btn" onClick={onClose}>
          {t.cancel}
        </button>
      </div>
    </CidrSheet>
  );
}
